export const cities = state => state.cities;
export const enabledCities = state =>
  citiesLoadInProgress(state)
    ? null
    : cities(state).filter(city => city.enabled && city.regionEnabled);
export const citiesLoadInProgress = state => state.cities === null;

export const city = state => state.city;
export const isCityLoading = state => state.city === null;



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/selectors/cities.js